import { Car } from "@/types/fleet";

export const parseCSV = async (csvText: string): Promise<Car[]> => {
  const lines = csvText.trim().split('\n');
  const headers = lines[0].split(',');
  
  return lines.slice(1).map(line => {
    const values = line.split(',');
    const car: any = {};
    
    headers.forEach((header, index) => {
      const key = header.trim();
      const value = values[index]?.trim();
      
      if (key === 'seats') {
        // Keep as string if it contains a range (e.g., "1-8"), otherwise parse as number
        car[key] = value?.includes('-') ? value : (parseInt(value) || 0);
      } else if (key === 'display_order' || key === 'year') {
        car[key] = parseInt(value) || 0;
      } else if (key === 'price_per_day_chf' || key === 'deposit_chf') {
        car[key] = parseInt(value) || 0;
      } else if (key === 'km_unlimited' || key === 'active') {
        car[key] = value?.toLowerCase() === 'true';
      } else {
        car[key] = value;
      }
    });
    
    return car as Car;
  });
};
